import React from "react";
import { motion } from "framer-motion";
import "./PackageCard.css";

const BASE_URL = 'https://atlastravelhouse.com';


function PackageCard({ pkg }) {
  const imageUrl = pkg.image
  ? pkg.image.startsWith("http://")
    ? pkg.image.replace("http://", "https://")
    : pkg.image.startsWith("https://")
      ? pkg.image
      : `${BASE_URL}${pkg.image}`
  : "";
  // console.log("image url:", imageUrl);
  return (
    <motion.div
      className="package-card"
      initial={{ opacity: 0, y: 50 }}    
      whileInView={{ opacity: 1, y: 0 }}   
      viewport={{ once: false, amount: 0.3 }} 
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <img src={imageUrl} alt={pkg.title} className="package-img" />
      <div className="package-overlay">
        <div className="package-content">
          <h3>{pkg.title}</h3>
          <p>{pkg.description}</p>
          <p><strong>Location:</strong> {pkg.location}</p>
          <p><strong>Duration:</strong> {pkg.duration}</p>
          <p><strong>Price:</strong> ₹ {pkg.price} (Per Person)</p>
        </div>
      </div>
    </motion.div>
  );
}

export default PackageCard;
